var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8849 32.1345C14.8849 34.6596 12.8379 36.7066 10.3127 36.7066C7.78755 36.7066 5.74051 34.6596 5.74051 32.1345C5.74051 29.6093 7.78755 27.5623 10.3127 27.5623C12.8379 27.5623 14.8849 29.6093 14.8849 32.1345Z",
    fill: "#0F8CE9",
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3127 26.8123C10.702 26.8132 11.0899 26.8566 11.4697 26.9419V0H9.15573V26.9419C9.53552 26.8566 9.92349 26.8132 10.3127 26.8123Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3127 37.4567C9.92349 37.4558 9.53552 37.4124 9.15573 37.3271V51.2883H11.4697V37.3271C11.0899 37.4124 10.702 37.4558 10.3127 37.4567Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2587 32.1345C53.2587 34.6596 51.2116 36.7066 48.6865 36.7066C46.1613 36.7066 44.1143 34.6596 44.1143 32.1345C44.1143 29.6093 46.1613 27.5623 48.6865 27.5623C51.2116 27.5623 53.2587 29.6093 53.2587 32.1345Z",
    fill: "#0F8CE9",
    stroke: "black",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6865 26.8123C48.2973 26.8132 47.9093 26.8566 47.5295 26.9419V0H49.8435V26.9419C49.4637 26.8566 49.0757 26.8132 48.6865 26.8123Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6865 37.4567C49.0757 37.4558 49.4637 37.4124 49.8435 37.3271V51.2883H47.5295V37.3271C47.9093 37.4124 48.2973 37.4558 48.6865 37.4567Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1682 16.7079C34.1682 19.2331 32.1212 21.2801 29.596 21.2801C27.0709 21.2801 25.0238 19.2331 25.0238 16.7079C25.0238 14.1828 27.0709 12.1357 29.596 12.1357C32.1212 12.1357 34.1682 14.1828 34.1682 16.7079Z",
    fill: "#68CD98",
    stroke: "black",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5961 11.3856C29.2068 11.3865 28.8188 11.43 28.4391 11.5152V0H30.7531V11.5152C30.3733 11.43 29.9853 11.3865 29.5961 11.3856Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5961 22.03C29.9853 22.0291 30.3733 21.9856 30.7531 21.9004V51.2882H28.4391V21.9004C28.8188 21.9856 29.2068 22.0291 29.5961 22.03Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLabel);
export default __webpack_public_path__ + "static/media/white-label.cf34601dceffa73b81419514997d216d.svg";
export { ForwardRef as ReactComponent };